import React from 'react';
import './NavBar.css';
import withBand from '../contextProviders/withBand';

export default withBand((({ token, band }) => {
    let loginToggle = null;
    let dashToggle = null;
    let picToggleStyle = null;

    if (!token) {
        loginToggle = <a className="nav-link align-middle flex" href="/login">Login</a>;
        dashToggle = <a className="nav-link align-middle flex" href="/register">Create Account</a>;
    } else {
        loginToggle = <a className="nav-link align-middle flex" href="/logout">Logout</a>;
        picToggleStyle = { backgroundColor: `#12345678` };
        if (band && band.image) {
            picToggleStyle = { backgroundImage: `url(${band.image})` };
        }

        dashToggle = <a className="nav-link align-middle flex" href="/artist-profile">Dashboard</a>;
    }

    return (

        <nav className="navbar" id="navbar">
            <a id="nav_pic" className="h-[25px] w-[50px] sm:h-[50px] sm:w-[100px] my-auto" href="/" aria-description='Request Love Home Photo'></a>

            <div className="navbar-collapse navbar-items flex align-middle mt-auto mb-auto">
                <ul className="navbar-list flex align-middle">
                    <li className="nav-item flex align-middle py-0 sm:py-2 my-auto">
                        <a className="nav-link align-middle flex" href="/features">Features</a>
                    </li>
                    <li className="nav-item flex align-middle py-0 sm:py-2 my-auto">
                        {dashToggle}
                    </li>
                    <li className="nav-item flex align-middle py-0 sm:py-2 my-auto">
                        {loginToggle}
                    </li>

                    {band &&
                        <li className="nav-item flex align-middle py-0 sm:py-2 my-0 sm:my-auto">
                            <div id="nav_pic" className="bg-cover bg-center w-10 h-10 rounded-full" style={picToggleStyle}></div>
                        </li>
                    }

                </ul>

            </div>
        </nav>
    );
}), false
);



